/**
 * The Product Roadmap module's permission vocabulary.
 *
 * Two rungs, like the wall planner. The product team edits; anyone given `view` (leadership,
 * sales, support) can follow what is launching when without being able to move it. There is no
 * per-product ownership check — the prototype let anyone in the team graduate anyone's product,
 * and the gate checklist, not the owner, is what guards a graduation.
 *
 * Comments need `edit` too: a viewer's question belongs in the team's channel, not on a card
 * they cannot act on. Marking your own mentions read needs only `view`.
 */
import { defineModulePermissions } from '@noissue/authz';

export const PRODUCT_ROADMAP = defineModulePermissions({
  id: 'product-roadmap',
  name: 'Product Roadmap',
  icon: 'package-check',
  permissions: {
    view: {
      label: 'View the product roadmap',
      description: 'See products, their gates, release dates and comments.',
    },
    edit: {
      label: 'Edit the product roadmap',
      description: 'Add products, tick ripples, graduate gates, comment and bank launches.',
    },
  },
  visibility: 'view',
  levels: [
    { key: 'view', label: 'View', grants: ['view'] },
    { key: 'edit', label: 'Edit', grants: ['view', 'edit'] },
  ],
});
